"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const PlayerModal_module_css_1 = __importDefault(require("./PlayerModal.module.css"));
/**
 * Generic full player takeover modal
 */
function PlayerModal({ title, isVisible, modalContent, primaryButtonLabel, secondaryButtonLabel, onPrimaryButtonClick, onSecondaryButtonClick, }) {
    const primaryButton = ((0, jsx_runtime_1.jsx)("div", { className: PlayerModal_module_css_1.default.footerButtonWrapper, children: (0, jsx_runtime_1.jsx)(web_sds_c_1.ColoredButton, { color: web_sds_c_1.ButtonColor.BLACK, onClick: onPrimaryButtonClick, children: primaryButtonLabel }) }));
    const secondaryButton = ((0, jsx_runtime_1.jsx)(web_sds_c_1.ColoredButton, { color: web_sds_c_1.ButtonColor.GRAY, onClick: onSecondaryButtonClick, children: secondaryButtonLabel }));
    let footer = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    if (primaryButtonLabel && secondaryButtonLabel) {
        footer = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [secondaryButton, primaryButton] }));
    }
    else if (primaryButtonLabel) {
        footer = primaryButton;
    }
    else if (secondaryButtonLabel) {
        footer = secondaryButton;
    }
    if (!isVisible) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: PlayerModal_module_css_1.default.modalContainer, "data-testid": "PlayerModal", children: [(0, jsx_runtime_1.jsxs)("div", { className: PlayerModal_module_css_1.default.bodyContainer, children: [(0, jsx_runtime_1.jsx)("div", { className: PlayerModal_module_css_1.default.title, children: (0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H5", children: title }) }), modalContent] }), (0, jsx_runtime_1.jsx)("div", { className: PlayerModal_module_css_1.default.footerContainer, children: footer })] }));
}
exports.PlayerModal = PlayerModal;
//# sourceMappingURL=PlayerModal.js.map